import { Card, CardHeader, CardContent, ToggleButton, ToggleButtonGroup, Typography, Grid } from "@mui/material";
import { useGetList } from "ra-core";
import { FC, useEffect, useMemo, useState } from "react";
import { RecPatch } from "@/dataProvider/tools";
import { LineChartWithPairsResponseDto, TimeRangeType } from "@/gen/api/metrics";
import { useDeploymentDetailContext } from "@/pages/deployment/useDeploymentDetailContext";
import { pages, sorts } from "@/utils/paramsWithGetMainList";
import { tbgSxProps } from "../overrides/toggleButtonGroupSx";
import CpuMemChart from "./CpuMemChart";
import DiskIOChart from "./DiskIOChart";

const ResourceMonitorMetrics: FC = () => {
  const [endTime, setEndTime] = useState((new Date()).toISOString())
  const [timeRangeType, setTimeRangeType] = useState(TimeRangeType.Hour)

  const { currDatabase } = useDeploymentDetailContext()
  const deploymentId = currDatabase?.deploymentId
  
  const { data: cpuMetrics, loading: loading1 } = useGetList<LineChartWithPairsResponseDto & RecPatch>(
    deploymentId ? 'dbmetrics-vmcpu' : 'noop', pages(), sorts(), {timeRangeType, endTime, deploymentId})
  const cpuLineData: LineChartWithPairsResponseDto & RecPatch | undefined = (cpuMetrics || {})[deploymentId + '-' + timeRangeType + '-' + endTime]
  const { data: memMetrics, loading: loading2 } = useGetList<LineChartWithPairsResponseDto & RecPatch>(
    deploymentId ? 'dbmetrics-vmmemory' : 'noop', pages(), sorts(), {timeRangeType, endTime, deploymentId})
  const memLineData: LineChartWithPairsResponseDto & RecPatch | undefined = (memMetrics || {})[deploymentId + '-' + timeRangeType + '-' + endTime]
  const { data: diskMetrics, loading: loading3 } = useGetList<LineChartWithPairsResponseDto & RecPatch>(
    deploymentId ? 'dbmetrics-vmdisk' : 'noop', pages(), sorts(), {timeRangeType, endTime, deploymentId})
  const diskLineData: LineChartWithPairsResponseDto & RecPatch | undefined = (diskMetrics || {})[deploymentId + '-' + timeRangeType + '-' + endTime]

  useEffect(() => {
    let timer: number | null = null
    if (timeRangeType === TimeRangeType.Hour) {
      timer = window.setInterval(() => {
        setEndTime((new Date()).toISOString())
      }, 2 * 60 * 1000)
    } else if (timer) {
      clearInterval(timer)
      timer = null
    }
    return () => { timer && clearInterval(timer) }
  }, [timeRangeType])

  return (
    <Card>
      <CardHeader 
        title="Resource Monitoring" 
        action={
          <ToggleButtonGroup
            size="small"
            sx={{
              ...tbgSxProps,
              mr: 2,
            }}
            exclusive
            value={timeRangeType}
            onChange={(e:any, v:TimeRangeType) => setTimeRangeType(v)}
          >
            <ToggleButton value={TimeRangeType.Hour}>
              <Typography variant="subtitle2" color="textSecondary">H</Typography>
            </ToggleButton>
            <ToggleButton value={TimeRangeType.Day}>
              <Typography variant="subtitle2" color="textSecondary">D</Typography>
            </ToggleButton>
            <ToggleButton value={TimeRangeType.Week}>
              <Typography variant="subtitle2" color="textSecondary">W</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        }
      />
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={6}>
            <CpuMemChart cpuLineData={cpuLineData} memLineData={memLineData} currDatabase={currDatabase} loading={loading1 || loading2} />
          </Grid>
          <Grid item xs={12} md={6}>
            <DiskIOChart diskLineData={diskLineData} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>

  )
}

export default ResourceMonitorMetrics;
